import React, { Fragment, useEffect, useState } from "react";

import useRequireAuth from "../../utils/useRequireAuth";
import LayoutHOC from "../LayoutHOC";
import { useFetchCompanyCommonDataQuery } from "../../utils/company/companySelector";
import CompanyDashboard from "./CompanyDashboard";
import MuiLoader from "../GlobalFeature/Loader/MuiLoader";
import Loader from "../UniversalComponents/Loader";
import { useLazyFetchCompanyDataIdQuery } from "../../utils/company/companypermissions";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { useSidebar } from "../SidebarContext";
import { getOrganizationName } from "../../utils/utilityFunctions/localServices";
import Header from "../Header2";
import { removeUser } from "../../utils/userSlice";
import { ReactComponent as LeftMenuIcon } from "../../assets/images/icons/Dashb.svg";
import { ReactComponent as LeftuserIcon } from "../../assets/images/icons/User_ManagementD.svg";
import { ReactComponent as LeftManageListIcon } from "../../assets/images/icons/LeftManageList.svg";
import { ReactComponent as Categorization } from "../../assets/images/icons/ct.svg";
import { ReactComponent as COA } from "../../assets/images/icons/Upload_COA.svg";
import { ReactComponent as LeftLogoutIcon } from "../../assets/images/icons/LeftLogout.svg";
import { useDispatch } from "react-redux";

const EditCompany = ({ onRefreshSidebar }) => {
  const [activeLink, setActiveLink] = useState(null);
  const { token } = useRequireAuth();
  const user = useRequireAuth();
  const dispatch = useDispatch();
  const data = useParams();
  const navigate = useNavigate();
  const companyLocalData = localStorage.getItem("company_data");
  const parsedCompanyData = JSON.parse(companyLocalData);
  let userToken = token || JSON.parse(localStorage.getItem("myUserData")).token;

  const [editCompany, setEditCompany] = useState([]);

  const { data: companyCommnData, isLoading, error } = useFetchCompanyCommonDataQuery(userToken);

  const [
    CompanyGetData,
    { data: companyEditData, isLoading: isCompanyEditDataLoading, error: companyEditDataError, refetch },
  ] = useLazyFetchCompanyDataIdQuery();

  // const sidebarContext = useSidebar();

  // for setting Header Props
  // const setheaderProps = sidebarContext?.setheaderProps;

  // useEffect(() => {
  //   {
  //     setheaderProps({
  //       name: getOrganizationName(),
  //     });
  //   }
  //   return () => {
  //     setheaderProps(null);
  //   };
  // }, []);

  const transformFormData = (data) => {
    const formattedData = {};

    // 1. Convert fixed_company_info to general_info
    if (data.fixed_company_info) {
      const generalInfo = [];

      for (const [key, value] of Object.entries(data.fixed_company_info)) {
        if (key === "business_category") {
          generalInfo.push({
            key,
            value: value.default_value ?? "",
          });
        } else {
          generalInfo.push({
            key,
            value: value ?? "",
          });
        }
      }

      formattedData["general_info"] = generalInfo;
    }

    // 2. Convert each section to desired format
    if (Array.isArray(data.sections)) {
      data.sections.forEach((section) => {
        const sectionKey = section.section_key;
        const fieldValues = [];

        section.fields.forEach((field) => {
          fieldValues.push({
            key: field.key,
            value: field.value ?? field.default_value ?? "",
          });
        });

        formattedData[sectionKey] = fieldValues;
      });
    }

    return formattedData;
  };
  console.log("companyeditid", data?.id);

  const handleTempFunc = async () => {
    try {
      const response = await CompanyGetData({ id: data?.id, page: "" || "" });
      if (response?.data?.success) {
        const filterData = transformFormData(response?.data?.data);
        setEditCompany(filterData);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    handleTempFunc();
  }, []);

  const handleSignOut = async () => {
    const Authtoken = user.token;
    try {
      dispatch(removeUser(null));
      navigate("/dashboard");
    } catch (error) {
      console.error("Logout failed:", error.message);
    }
  };

  const handleMenuClick = (index) => {
    setActiveLink(index); // Set active link on menu click
  };
  const getUserAccess = (value) => {
    const accessFlag = user?.permissions?.find(
      (ob) => ob?.sub_module?.toLowerCase() === value?.toLowerCase()
    )?.permission;
    return accessFlag === 1;
  };

  const sidebarLinks = [
    { title: "Dashboard", path: "/dashboardMain", icon: <LeftMenuIcon />, onClick: null },
    { title: "User Management", path: "/user", icon: <LeftuserIcon />, onClick: null, checkPermission: true },
    // {
    //   title: "Manage Permissions",
    //   path: "/manage_permission",
    //   icon: <LeftManageIcon />,
    //   onClick: null,
    //   checkPermission: true,
    // },
    { title: "Manage List", path: "/managelist", icon: <LeftManageListIcon />, onClick: null, checkPermission: true },
    {
      title: "Categorization",
      path: null,
      onClick: () => {
        const Authtoken = user.token;
        const url = `https://vgen.aizooks.com/index.html?accessin=${Authtoken}`;
        window.open(url, "_blank"); // opens in a new tab
      },
      icon: <Categorization />,
    },

    {
      title: "Upload Chart of Accounts",
      path: null,
      onClick: () => {
        const Authtoken = user.token;
        const url = `https://vgen.aizooks.com/upload-coa-data.html?accessin=${Authtoken}`;
        window.open(url, "_blank"); // opens in a new tab
      },
      icon: <COA />,
    },
    { title: "Logout", path: null, icon: <LeftLogoutIcon />, onClick: handleSignOut },
  ];

  return (
    <Fragment>
      <Loader isOpen={isLoading} />
      <div className="h-full w-full flex flex-col gap-4">
        <Header />
        <div className="md:mx-4 font-poppins flex grow min-h-0">
          {/* left menu bar */}
          <div className="bg-white shadow-md rounded-md w-16 h-[calc(100vh-363px)] mx-3 border-[1px] border-[#D2DAE1] overflow-y-auto scrollbar-hidden">
            <ul className="text-gray-600 rounded-md flex items-center justify-center flex-col ">
              {sidebarLinks
                .filter((eachSidebar) => getUserAccess(eachSidebar.title) || !eachSidebar.checkPermission)
                .map((link, index) =>
                  link.path ? (
                    <li key={index} className="p-2 mt-4 hover:bg-[#F0F0F0] rounded-lg">
                      <NavLink exact="true" to={link.path} onClick={() => handleMenuClick(index)}>
                        {link.icon}
                      </NavLink>
                    </li>
                  ) : (
                    <li
                      key={index}
                      onClick={() => {
                        handleMenuClick(index);
                        if (link.onClick) link.onClick();
                      }}
                      className="p-2 mt-4 hover:bg-[#F0F0F0] cursor-pointer rounded-lg"
                    >
                      <span>{link.icon}</span>
                    </li>
                  )
                )}
            </ul>
          </div>

          <CompanyDashboard EditCompanyData={editCompany} setEditCompany={setEditCompany} isEdit />
        </div>
      </div>
    </Fragment>
  );
};
// export default LayoutHOC(EditCompany);
export default EditCompany;
